<template>
    <div>
        <b-row class="flex justify-center">
            <b-col
                v-for="(serviceType) in serviceTypes"
                :key="serviceType.found.id"
                cols="12"
                md="3"
                class="mb-3"
            >
                <b-form-group :label="serviceType.name">
                <b-form-select
                    v-model="serviceType.matchedSelected.id"
                    :options="$root.auxVars.serviceTypesOpts"
                    @change="updateSelected(serviceType)"
                ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
    props: {
        serviceTypes: {
            type: Array,
            required: true,
        }
    },
    methods: {
        updateSelected() {} ,
    },
    mounted(){
        this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ['serviceTypesOpts']
		});
    
    }
};
</script>
